import { observer } from "mobx-react";
import React, { useState } from "react";
import {
  Center,
  Paper,
  Stack,
  Image,
  Alert,
  Text,
  Button,
  Loader,
} from "@mantine/core";
import { IconAlertTriangle, IconReload } from "@tabler/icons-react";
import { Bob } from "../../stores/Bob";

const YouHaveBeenDisconnected = observer(({ bob }: { bob: Bob }) => {
  const [isReloading, setIsReloading] = useState(false);

  const handleReload = () => {
    setIsReloading(true);
    location.replace("/w");
  };

  return (
    <Center
      component="main"
      pos="fixed"
      inset={0}
      style={{
        paddingTop: "max(16px, env(safe-area-inset-top))",
        paddingRight: "max(16px, env(safe-area-inset-right))",
        paddingBottom: "max(16px, env(safe-area-inset-bottom))",
        paddingLeft: "max(16px, env(safe-area-inset-left))",
      }}
    >
      <Paper
        shadow="md"
        radius="lg"
        p="xl"
        withBorder
        style={{ width: "min(96vw, 520px)", marginInline: "auto" }}
      >
        <Stack gap="lg" align="center">
          <Image
            src="https://daxwktpz4hkwd.cloudfront.net/logos/rizful-logo-mobile.png"
            alt="Rizful logo"
            fit="contain"
            style={{ width: "clamp(140px, 36vw, 260px)" }}
          />

          <Alert
            color="yellow"
            variant="outline"
            icon={<IconAlertTriangle size={24} />}
            style={{ width: "100%", background: "transparent" }}
          >
            <Text size="md" ta="center">
              To be sure you have the latest updates, please reload the page to
              use Rizful.
            </Text>
          </Alert>

          <Button
            fullWidth
            size="md"
            onClick={handleReload}
            leftSection={
              isReloading ? <Loader size="sm" /> : <IconReload size={16} />
            }
            disabled={isReloading}
          >
            {isReloading ? "Reloading…" : "Reload Page"}
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
});

export default YouHaveBeenDisconnected;
